import React from 'react'

export default function How() {
  return (
    <div>
      <h3 className='text-5xl navbar-brand text-center'>Comment ca marche ?</h3>
      <div className="row mt-3 bg-light p-3 flex gap-10 justify-center items-center">
       <h2 className='text-5xl '>PAGE EN CONSTRUCTION...</h2>
      </div>
    </div>
  )
}
